import { Link, useLocation } from "wouter";
import "./Login.css"
import axios from "axios";
import { api } from "../../settings/env";
import { useState } from "react";

export function Login() {
    const [location, setLocation]   = useLocation();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    
    const login = () => {
        // TODO: Implementar la lógica para el login
        console.log("Login");
        
        const data = {
            email,
            password,
        }

        axios.post(`${api}/register/login-professional`, data)
           .then(response => {
                if (response.data.success){
                    console.log("Login exitoso", response.data);
                    //alert("Login exitoso");
                    
                    // Guardar en el local storage
                    localStorage.setItem("vitaly_profile", response.data.profilePicture);
                    localStorage.setItem("vitaly_type", response.data.type);
                    localStorage.setItem("vitaly_userid", response.data.data.user_id);
                    

                    // TODO: Redireccionar al home
                    setLocation("/");
                    

                } else {
                    alert("Email o contraseña incorrectos");
                }
           })
           .catch(error => {
                console.error(error);
                alert("Error en el login");
           });
    }
    
    return (
        <div className="login">
            <div className="form-login">


                <div className="form">
                    <div className="logo">
                        <Link to="/">
                            <img src="/assets/vitaly.webp" alt="" />
                        </Link>
                    </div>

                    <h1>
                        <b>¡Bienvenido!</b>
                    </h1>
                    <p className="subtitle mb-4">
                        ¡Es momento de revisar tus proximas consultas!
                    </p>

                    <div class="mb-3">
                        <input
                            type="email"
                            class="form-control"
                            placeholder="Email"
                            onKeyUp={(e) => setEmail(e.target.value)}
                        />
                        {/* <div id="emailHelp" class="form-text">We'll never share your email with anyone else.</div> */}
                    </div>
                    <div class="mb-3">
                        <input
                            type="password"
                            class="form-control"
                            placeholder="Contraseña"
                            onKeyUp={(e) => setPassword(e.target.value)}
                        />
                    </div>

                    <p className="text-left">
                        <Link to="/reset-password">
                            ¿Olvidaste la contraseña?
                        </Link>
                    </p>


                    <button onClick={login} class="btn btn-primary">
                        Iniciar sesion
                    </button>

                    <p className="text-center">
                        ¿No tienes cuenta? <Link to="/register">¡Regístrate aquí!</Link>
                    </p>
                </div>


            </div>

            <div className="box-banner-login">
                <div className="boxbanner">
                    
                <h2>
                            Accede a una red exclusiva de 
                            profesionales de la salud
                        </h2>

                        <p>
                            Y disfruta de una atención de calidad
                        </p>

                    <div className="steps-banner">

                        

                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
            </div>
        </div>
    );
}